import {apiCall} from './api'

export const GET_USER_GROUPS = 'GET_USER_GROUPS'
export const getUserGroups = () =>({
  type:GET_USER_GROUPS,
  payload: apiCall('AllUserGroups', {})
})
